import { Box, Center, Loader, Stack, Text } from '@mantine/core';
import { BrandName } from '../shared/BrandName';

interface FullScreenLoadingProps {
  message?: string;
}

export default function FullScreenLoading({ message = 'Getting things ready…' }: FullScreenLoadingProps) {
  return (
    <Center
      mih="100dvh"
      p="xl"
      style={{
        background:
          'radial-gradient(circle at 15% 10%, rgba(53, 214, 255, 0.2), transparent 32rem), radial-gradient(circle at 90% 88%, rgba(8, 127, 231, 0.24), transparent 34rem), #0a1630',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        aria-hidden="true"
        pos="absolute"
        inset={0}
        opacity={0.22}
        style={{
          backgroundImage: 'radial-gradient(rgba(255, 255, 255, 0.28) 0.65px, transparent 0.65px)',
          backgroundSize: '9px 9px',
          pointerEvents: 'none',
        }}
      />
      <Stack align="center" gap="lg" pos="relative" role="status" aria-live="polite">
        <Stack align="center" gap="sm">
          <Box
            aria-hidden="true"
            w={58}
            h={58}
            style={{
              background: 'linear-gradient(135deg, #ffffff 5%, #35d6ff 50%, #087fe7 100%)',
              WebkitMask: 'url(/data/logo.svg) center / contain no-repeat',
              mask: 'url(/data/logo.svg) center / contain no-repeat',
            }}
          />
          <BrandName size="large" color="#ffffff" />
        </Stack>
        <Loader size="md" color="cyan.4" type="dots" />
        <Text c="gray.3" size="sm">
          {message}
        </Text>
      </Stack>
    </Center>
  );
}
